import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Footer from '../Components/Footer';
import Auth from '../Function/Auth';
import Header from '../Components/Header';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function Withdraw() {
    const authToken = localStorage.getItem('token');
    const baseurl = process.env.REACT_APP_BASE_API_URL;
    const [analytics, setAnalytics] = useState({});
    const [tableLoading, setTableLoading] = useState(false);
    const [clientData, setClientData] = useState([]);
    const [pagination, setPagination] = useState({
        current_page: 1,
        limit: 10,
        total_records: 0,
        total_pages: 0,
    });
    const [userId, setUserId] = useState('');
    const [withdrawAsset, setWithdrawAsset] = useState('');
    const [userStatus, setUserStatus] = useState('');
    const [date, setDate] = useState('');

    useEffect(() => {
        fetchDataWithdrawals(1);
    }, []);

    const fetchDataWithdrawals = async (page) => {
        setTableLoading(false);
        const queryParams = new URLSearchParams({
            page,
            userid: userId,
            withdrawAsset,
            status: userStatus,
            date,
        }).toString();

        try {
            const response = await fetch(`${baseurl}/withdrawList.php?${queryParams}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${authToken}`,
                },
            });

            if (response.status === 429) {
                toast.error('Rate limit exceeded. Please try again later.');
                setTableLoading(true);
                return;
            }

            const data = await response.json();
            console.log('API Response:', data);

            if (data.status) {
                setClientData(data.data);
                setPagination(data.pagination);
                setAnalytics({
                    total: data.statistics.total_withdrawals,
                    pending: data.statistics.pending_withdrawals,
                    completed: data.statistics.completed_withdrawals,
                    rejected: data.statistics.rejected_withdrawals,
                });
                setTableLoading(true);
            } else {
                toast.error(data.message || 'Failed to fetch withdrawal data');
                setTableLoading(true);
            }
        } catch (error) {
            console.error('Fetch error:', error);
            toast.error('Network error. Please check your connection and try again.');
            setTableLoading(true);
        }
    };

    const handlePageChange = (page) => {
        if (page >= 1 && page <= pagination.total_pages) {
            fetchDataWithdrawals(page);
        }
    };

    const searchData = () => {
        fetchDataWithdrawals(1);
    };

    const handleProfileDataFetched = (data) => {
        // Handle profile data if needed
    };

    return (
        <>
            <Header>
                {!authToken && <Auth onProfileDataFetched={handleProfileDataFetched} />}
                <div className="main-content app-content">
                    <div className="container-fluid">
                        {/* Page Header */}
                        <div className="d-md-flex d-block align-items-center justify-content-between my-4 page-header-breadcrumb">
                            <h1 className="page-title">Withdrawal Management</h1>
                        </div>

                        {/* Analytics Cards */}
                        <div className="row">
                            <div className="col-xl-3 col-lg-6 col-md-6 col-sm-12">
                                <div className="card overflow-hidden sales-card bg-primary-gradient">
                                    <div className="px-3 pt-3 pb-2">
                                        <h6 className="mb-3 fs-12 text-fixed-white">TOTAL WITHDRAWALS</h6>
                                        <h4 className="fs-20 fw-bold mb-1 text-fixed-white">
                                            {analytics.total || 0}
                                        </h4>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-3 col-lg-6 col-md-6 col-sm-12">
                                <div className="card overflow-hidden sales-card bg-warning-gradient">
                                    <div className="px-3 pt-3 pb-2">
                                        <h6 className="mb-3 fs-12 text-fixed-white">PENDING WITHDRAWALS</h6>
                                        <h4 className="fs-20 fw-bold mb-1 text-fixed-white">
                                            {analytics.pending || 0}
                                        </h4>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-3 col-lg-6 col-md-6 col-sm-12">
                                <div className="card overflow-hidden sales-card bg-success-gradient">
                                    <div className="px-3 pt-3 pb-2">
                                        <h6 className="mb-3 fs-12 text-fixed-white">COMPLETED WITHDRAWALS</h6>
                                        <h4 className="fs-20 fw-bold mb-1 text-fixed-white">
                                            {analytics.completed || 0}
                                        </h4>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-3 col-lg-6 col-md-6 col-sm-12">
                                <div className="card overflow-hidden sales-card bg-danger-gradient">
                                    <div className="px-3 pt-3 pb-2">
                                        <h6 className="mb-3 fs-12 text-fixed-white">REJECTED WITHDRAWALS</h6>
                                        <h4 className="fs-20 fw-bold mb-1 text-fixed-white">
                                            {analytics.rejected || 0}
                                        </h4>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Filter Section */}
                        <div className="row">
                            <div className="col-md-12 col-lg-12 col-xl-12">
                                <div className="card card-table">
                                    <div className="row">
                                        <div className="col-xl-3 col-lg-6 col-md-6 col-sm-12">
                                            <div className="mt-3">
                                                <label>User ID</label>
                                                <input
                                                    type="text"
                                                    value={userId}
                                                    onChange={(e) => setUserId(e.target.value)}
                                                    className="form-control"
                                                    placeholder="Enter user ID"
                                                />
                                            </div>
                                        </div>
                                        <div className="col-xl-3 col-lg-6 col-md-6 col-sm-12">
                                            <div className="mt-3">
                                                <label>Withdraw Asset</label>
                                                <input
                                                    type="text"
                                                    value={withdrawAsset}
                                                    onChange={(e) => setWithdrawAsset(e.target.value)}
                                                    className="form-control"
                                                    placeholder="Enter asset (e.g., USDT)"
                                                />
                                            </div>
                                        </div>
                                        <div className="col-xl-3 col-lg-6 col-md-6 col-sm-12">
                                            <div className="mt-3">
                                                <label>Status</label>
                                                <select
                                                    className="form-control"
                                                    value={userStatus}
                                                    onChange={(e) => setUserStatus(e.target.value)}
                                                >
                                                    <option value="">All</option>
                                                    <option value="pending">Pending</option>
                                                    <option value="success">Success</option>
                                                    <option value="rejected">Rejected</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-xl-3 col-lg-6 col-md-6 col-sm-12">
                                            <div className="mt-3">
                                                <label>Request Date</label>
                                                <input
                                                    type="date"
                                                    value={date}
                                                    onChange={(e) => setDate(e.target.value)}
                                                    className="form-control"
                                                />
                                            </div>
                                        </div>
                                        <div className="col-xl-3 col-lg-6 col-md-6 col-sm-12">
                                            <div className="mt-3 text-end">
                                                <button
                                                    onClick={searchData}
                                                    className="btn btn-primary btn-block mt-4"
                                                >
                                                    Search
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Table Section */}
                        <div className="row">
                            <div className="col-md-12 col-lg-12 col-xl-12">
                                <div className="card card-table">
                                    <div className="card-header p-0 d-flex justify-content-between mt-3">
                                        <h3 className="card-title mb-1 text-primary">Withdrawal Data</h3>
                                    </div>
                                    <div className="table-responsive country-table">
                                        {tableLoading ? (
                                            <table className="table table-striped table-bordered mb-0 text-nowrap mt-3">
                                                <thead>
                                                    <tr>
                                                        <th>USER</th>
                                                        <th>TXN ID</th>
                                                        <th>ASSET</th>
                                                        <th>WITHDRAW AMOUNT</th>
                                                        <th>TXN FEES</th>
                                                        <th>TO ADDRESS</th>
                                                        <th>TXN HASH</th>
                                                        <th>REQUEST TIME</th>
                                                        <th>CONFIRM TIME</th>
                                                        <th>STATUS</th>
                                                        <th>REMARK</th>
                                                        <th>ACTION</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {clientData.length > 0 ? (
                                                        clientData.map((dataClient, index) => (
                                                            <tr key={index}>
                                                                <td>
                                                                    <h5>{dataClient.user_name || 'N/A'}</h5>
                                                                    <span>({dataClient.userid})</span>
                                                                </td>
                                                                <td>{dataClient.txnId || 'N/A'}</td>
                                                                <td>{dataClient.withdrawAsset || 'N/A'}</td>
                                                                <td>${dataClient.withdrawAmount?.toFixed(2) || '0.00'}</td>
                                                                <td>${dataClient.txnFees?.toFixed(2) || '0.00'}</td>
                                                                <td>{dataClient.toAddress || 'N/A'}</td>
                                                                <td>{dataClient.txnHash || 'N/A'}</td>
                                                                <td>{dataClient.requestTime || 'N/A'}</td>
                                                                <td>{dataClient.confirmTime || 'N/A'}</td>
                                                                <td>
                                                                    <span
                                                                        className={`badge bg-${dataClient.status === 'completed'
                                                                            ? 'success'
                                                                            : dataClient.status === 'pending'
                                                                                ? 'warning'
                                                                                : 'danger'
                                                                            }`}
                                                                    >
                                                                        {dataClient.status || 'N/A'}
                                                                    </span>
                                                                </td>
                                                                <td>{dataClient.remark || 'N/A'}</td>
                                                                <td>
                                                                    <Link
                                                                        to={`/withdrawalDetails?withdrawId=${dataClient.id}`}
                                                                        className="btn btn-sm btn-primary"
                                                                    >
                                                                        <i className="fa fa-eye"></i>
                                                                    </Link>
                                                                </td>
                                                            </tr>
                                                        ))
                                                    ) : (
                                                        <tr>
                                                            <td colSpan="12" className="text-center">
                                                                No Data Found
                                                            </td>
                                                        </tr>
                                                    )}
                                                </tbody>
                                            </table>
                                        ) : (
                                            <div className="text-center">
                                                <div className="spinner-border" role="status">
                                                    <span className="visually-hidden">Loading...</span>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                    <div className="gridjs-footer">
                                        <div className="gridjs-pagination">
                                            <div role="status" aria-live="polite" className="gridjs-summary">
                                                Showing <b>{(pagination.current_page - 1) * pagination.limit + 1}</b> to{' '}
                                                <b>
                                                    {Math.min(pagination.current_page * pagination.limit, pagination.total_records)}
                                                </b>{' '}
                                                of <b>{pagination.total_records}</b> results
                                            </div>
                                            <div className="gridjs-pages text-end">
                                                <button
                                                    className={pagination.current_page === 1 ? 'disabled' : ''}
                                                    onClick={() => handlePageChange(pagination.current_page - 1)}
                                                    disabled={pagination.current_page === 1}
                                                >
                                                    Previous
                                                </button>
                                                <button
                                                    className={pagination.current_page === 1 ? 'gridjs-currentPage' : ''}
                                                    onClick={() => handlePageChange(1)}
                                                >
                                                    1
                                                </button>
                                                {pagination.current_page > 3 && <span>...</span>}
                                                {Array.from({ length: 5 }, (_, i) => {
                                                    const page = pagination.current_page - 2 + i;
                                                    if (page > 1 && page < pagination.total_pages) {
                                                        return (
                                                            <button
                                                                key={page}
                                                                className={pagination.current_page === page ? 'gridjs-currentPage' : ''}
                                                                onClick={() => handlePageChange(page)}
                                                            >
                                                                {page}
                                                            </button>
                                                        );
                                                    }
                                                    return null;
                                                })}
                                                {pagination.current_page < pagination.total_pages - 2 && <span>...</span>}
                                                {pagination.total_pages > 1 && (
                                                    <button
                                                        className={
                                                            pagination.current_page === pagination.total_pages ? 'gridjs-currentPage' : ''
                                                        }
                                                        onClick={() => handlePageChange(pagination.total_pages)}
                                                    >
                                                        {pagination.total_pages}
                                                    </button>
                                                )}
                                                <button
                                                    className={pagination.current_page === pagination.total_pages ? 'disabled' : ''}
                                                    onClick={() => handlePageChange(pagination.current_page + 1)}
                                                    disabled={pagination.current_page === pagination.total_pages}
                                                >
                                                    Next
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <ToastContainer />
            </Header>
            <Footer />
        </>
    );
}

export default Withdraw;